'use strict';

module.exports = {
  'Other': '000',
  'NY': '001',
  'NJ': '001',
  'DC': '002',
  'MA': '003',
  'CA': '004',
  'MD': '005',
  'MO': '006',
  'PA': '007'
};